import { InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { azureADUser } from '../models/azureAD-User.model';
import { AzureADOrg } from '../models/azureADOrg.model';

export const IDIRECTORYSERVICE = new InjectionToken<IDirectoryService>('title');

/** Directory facade used for login + profile (Signature / User Attributes app). */
export interface IDirectoryService {
  directoryUrl: string;
  profilePic: BehaviorSubject<Blob[] | null>;

  getUserInfo(): Observable<azureADUser>;
  getOrg(): Observable<AzureADOrg>;
  getProfilePic(): Observable<Blob>;
}
